import usePrivateAxios from "@/common/api/usePrivateAxios";
import { PermissionData, PermissionResponse } from "@/common/types/permissions";
import { UseQueryResult, useQuery } from "@tanstack/react-query";

const usePermission: (id: string) => UseQueryResult<PermissionData, unknown> = (id) => {
  const privateAxios = usePrivateAxios()

  return useQuery<PermissionResponse, unknown, PermissionData>({
    queryKey: ['permission', id],
    queryFn: () => privateAxios.get(`/permissions/${id}`),
    select: (data) => data?.data?.data
  });
};

export default usePermission;
